import { render, staticRenderFns } from "./VenueInspectionLists.vue?vue&type=template&id=15395d58&scoped=true&"
import script from "./VenueInspectionLists.vue?vue&type=script&lang=js&"
export * from "./VenueInspectionLists.vue?vue&type=script&lang=js&"
import style0 from "./VenueInspectionLists.vue?vue&type=style&index=0&id=15395d58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15395d58",
  null
  
)

export default component.exports